import * as React from "react";
import { renderTeam } from "./renderTeam";
import { renderLeague } from "./renderLeague";
export const renderTeamsWrapper = (event, componentPrefix, showLeagueInEventCard) => React.createElement("div", { className: `rj-ev-list__${componentPrefix}__section-item rj-ev-list__${componentPrefix}__names`, "data-uat": `div-ev-list-${componentPrefix}-names` },
    renderLeague(showLeagueInEventCard, event.leagueName, componentPrefix),
    renderTeam(event, "1", componentPrefix),
    renderTeam(event, "2", componentPrefix));
//# sourceMappingURL=renderTeamsWrapper.js.map